var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"top","content":_vm.localizedEnum,"open-delay":300}},[_c('i',{staticClass:"fa font_lg secondary_color enum_icon",class:_vm.icon,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }